import { borderRadius, Button, typographyV2 } from '@toggle/design-system';
import styled, { css } from 'styled-components';

export const StyledButton = styled(Button)<{ $isTracked: boolean }>`
  ${borderRadius.r2}
  padding: 6px 12px;
  ${typographyV2.uiSm};

  ${({ $isTracked }) =>
    $isTracked &&
    css`
      border-color: var(--border-success);
      color: var(--text-success);
      &:hover {
        color: var(--text-success);
        background-color: var(--surface-success);
      }
      svg {
        fill: var(--icon-success);
      }
    `}
`;
